import { device } from 'src/styles/breakpoints'
import { white } from 'src/styles/colors'
import styled from 'styled-components'

export const TabSection = styled.section`
  padding-top: 40px;
  padding-bottom: 40px; 

  @media ${device.desktopLG} {
    padding-top: 64px;
  }
  @media ${device.desktopXL} {
    padding-top: 96px;
  }
  h4 {
    font-family: "Inter", Helvetica, sans-serif !important;
    font-size: 14px;
  }
  
  .tab-ul {
    overflow-y: hidden;
    li {
      @media ${device.tablet} {
        margin: 0 10px !important;
      }
    }
    li:nth-child(2) {
      h4 {
        width: 228px;
      }
    }
  }

  @media ${device.tablet} {
    height: auto;
  }

  nav {
    ul {
      border-bottom: 4px solid ${white};
      @media ${device.desktopLG} {
        justify-content: start !important;
      }
      li {
        &:first-child {
          margin-left: 0;
        }
        @media ${device.tablet} {
          margin: 0 60px;

          &:last-child {
            margin-right: 0;
          }
        }
        @media ${device.desktopLG} {
          margin: 0 40px 0 0;

          button {
            padding-left: 0;
          }
        }
      }
    }
  }

  @media ${device.tablet} {
    min-height: 368px;
  }

  .react-multi-carousel-dot {
    margin: 0;
  }
  .react-multiple-carousel__arrow--left {
    left: -8px;
  }
  .react-multiple-carousel__arrow--right {
    right: -8px;

    @media ${device.desktopLG} {
      right: 4px;
    }
  }
`
export const BoxWhiteCarousel = styled.div`

  > div {
    min-height: 259px;
    border: 1px solid #B6B7BB;
    p {
      font-family: "Sora", Helvetica, sans-serif;
    }
  }
  li.react-multi-carousel-dot {
    margin: 0;
  }
`
